import React from 'react'
import { useTranslation, useRequest } from '@hooks'
import { Popconfirm, Button } from '@components'
import { api, message } from '@services'
import { ButtonType, TUser } from '@typings'

const VerifyUserLink: React.FC<TProps> = ({ userId, buttonType = 'default', onSuccess }) => {
	const { t } = useTranslation()

	const { fetch: removeUser, fetching: removing } = useRequest<void, any>({
		request: () => api.sendCode(userId),
		onSuccess: () => onSuccess?.(),
		onError: (error) => message.error(error.message),
	})

	return (
		<Popconfirm title={t('Are you sure?')} okText={t('Yes')} cancelText={t('No')} onConfirm={removeUser}>
			<Button loading={removing} type={buttonType}>
				{t('Send code')}
			</Button>
		</Popconfirm>
	)
}

type TProps = {
	/** Id of terget user.  */
	userId: TUser['id']
	/** Callback called after successful removing. */
	onSuccess: () => void
	/** Type of button link */
	buttonType?: ButtonType
}

export default VerifyUserLink
